// styles
import { styled } from '@mui/material/styles';
// components
import { Grid, Link, Typography, Button, Box, IconButton, useMediaQuery } from '@mui/material';
import { footerConfig } from '../navbar/NavConfig';
import LogoImage from '../../../../assets/footerLogo.png';
import themeImage from '../../../../assets/themeImage.png';
import people from '../../../../assets/people.png';
import { Iconify } from '../../../../shared/components/base';

// ----------------------------------------------------------------------

const RootStyle = styled('footer')(({ theme }) => ({
  backgroundColor: 'black',
  padding: theme.spacing(3, 0),
  borderTop: '1px solid rgba(128, 128, 128, 0.5)',
  textAlign: 'center',
}));

export default function DashboardFooter() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#F8F8F8',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: isMobile ? 'center' : 'flex-start',
          width: '100%',
          marginTop: -5,
        }}
      >
        <Grid
          container
          maxWidth="xl"
          mx="auto"
          spacing={0}
          alignItems="center"
          justifyContent={isMobile ? 'center' : 'flex-end'}
        >
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                px: 2,
                py: 4,
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 'bold',
                  mb: 2,
                  textAlign: 'left',
                  fontSize: { xs: '2.5rem', md: '3rem' },
                }}
              >
                Join Our Community!
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  textAlign: 'left',
                  color: '#555',
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  lineHeight: 1.5,
                }}
              >
                Want to earn more, save more and be the best version of yourself? Join our community for side hustle
                tips, smart savings tricks, and productivity hacks delivered straight to your inbox. Sign up now - your
                future self will thank you!
              </Typography>
            </Box>
          </Grid>

          {!isMobile && (
            <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center', mb: 0, mt: 0 }}>
              <Box
                sx={{
                  borderRadius: '20px',
                  overflow: 'hidden',
                  width: '100%',
                  height: 'auto',
                  maxWidth: '350px',
                }}
              >
                <img
                  src={people}
                  alt="People"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
        {!isMobile && (
          <img
            src={themeImage}
            alt="Theme"
            style={{
              width: '25%',
              height: 'auto',
              objectFit: 'cover',
            }}
          />
        )}
      </Box>

      <RootStyle>
        <Grid
          container
          alignItems="center"
          justifyContent={isMobile ? 'center' : 'space-around'}
          spacing={10}
          sx={{ px: 20 }}
        >
          <Grid item>
            <img
              src={LogoImage}
              alt="Footer Logo"
              style={{ maxWidth: '200px', display: isMobile ? 'none' : 'block' }}
            />
          </Grid>
          <Grid item>
            <Grid container direction="column" alignItems="center" spacing={4}>
              <Grid item>
                <Grid container justifyContent="center" alignItems="center" spacing={2}>
                  {footerConfig.map((item, index) => (
                    <Grid item key={index}>
                      <Link
                        href={item.path}
                        target="_blank"
                        rel="noopener"
                        underline="hover"
                        sx={{
                          color: 'white',
                          fontWeight: 500,
                          padding: 2,
                          '&:hover': {
                            textDecorationColor: '#2574EB',
                            textUnderlineOffset: '10px',
                          },
                        }}
                      >
                        {item.title}
                      </Link>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  <Link
                    href="https://stintz.com/privacy-notice/"
                    target="_blank"
                    rel="noopener"
                    underline="hover"
                    sx={{
                      color: '#2574EB',
                      fontWeight: 500,
                      marginRight: 2,
                      '&:hover': {
                        color: 'white',
                      },
                    }}
                  >
                    Privacy Notice
                  </Link>

                  <Link
                    href="https://stintz.com/terms-conditions/"
                    target="_blank"
                    rel="noopener"
                    underline="hover"
                    sx={{
                      color: '#2574EB',
                      fontWeight: 500,
                      marginLeft: 2,
                      '&:hover': {
                        color: 'white',
                      },
                    }}
                  >
                    Terms & Conditions
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{
                height: 50,
                width: 50,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#2574EB',
                borderRadius: '15px',
                '&:hover': {
                  backgroundColor: '#1E5BBF',
                },
              }}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              <Iconify icon="ri:arrow-drop-up-line" width={40} height={40} style={{ color: 'white' }} />
            </IconButton>
          </Grid>
        </Grid>
      </RootStyle>
    </>
  );
}
